import { types, actions } from './requests'
export const GETITEMCOSTS_TYPES = {
    ...types('GETITEMCOSTS'),
}
export const GETITEMCOSTS_ACTIONS = {
    ...actions('GETITEMCOSTS'),
}
